module.exports = __webpack_public_path__ + "static/media/favicon-vm.87fd3a76.ico";